import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import "./style/Beauty.style.scss";
export default function BeautyHeader() {
  const handleScroll = () => {
    let number =
      window?.pageXOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      3;
    if (number >= 5) {
      if (window.innerWidth < 5) {
        document
          .getElementById("py-header")
          ?.classList.remove("pay-header-sticky");
      } else {
        document
          .getElementById("py-header")
          ?.classList.add("pay-header-sticky");
      }
    } else {
      document
        .getElementById("py-header")
        ?.classList.remove("pay-header-sticky");
    }
  };

  const router = useNavigate();

  useEffect(() => {
    try {
      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    } catch (error) {
      // console.log("err", error.message);
    }
  }, []);

  return (
    <>
      <section className="d-none">
        <div id="py-header" className="px-3 pay-header bg-white border-bottom">
          <div className="d-lg-flex justify-content-between align-items-center">
            <div className=" gap-3">
              <h5 className="mb-0 d-lg-block d-none">Beauty</h5>
              <div className="d-lg-none">
                <h4
                  role="button"
                  data-bs-toggle="collapse"
                  href="#retailMenue"
                  aria-expanded="false"
                  aria-controls="retailMenue"
                  className="p-2 d-flex mb-0 align-items-center "
                >
                  Retail <KeyboardArrowDownIcon />
                </h4>
                <div className="collapse w-100" id="retailMenue">
                  <div className="card border-0 card-body menu_jh  w-100 text-start">
                    <div className="d-flex gap-2 flex-wrap">
                      <button
                        type="button"
                        onClick={() => router("/get-started")}
                        className="btn btn-sn "
                      >
                        Get Started
                      </button>
                      <button
                        type="button"
                        onClick={() => router("/contact")}
                        className="btn btn-sn "
                      >
                        Contacted Sales
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-lg-flex d-none gap-3 align-items-center">
              <button
                onClick={() => router("/get-started")}
                type="button"
                className="btn btn-gd "
              >
                Get Started
              </button>
              <button
                type="button"
                onClick={() => router("/contact")}
                className="btn btn-sn ]"
              >
                Contact Sales
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
